import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_253dfa48";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_253dfa48" };
/** script content **/
require("./radio-modal.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex253dfa48%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fradio-modal%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_253dfa48"],
    ctorType: "component",
    outputPath: "components/index253dfa48/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-modal': getComponent(require("../modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")), 'cube-radio': getComponent(require("../radio/index.mpx?isComponent&outputPath=components%2Findex4aa5b228%2Findex")), 'cube-radio-group': getComponent(require("../radio-group/index.mpx?isComponent&outputPath=components%2Findex467050cc%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
